import HomePageSearchHero from '@components/Home/HomePageSearchHero'
import LastKurantimePost from '@components/Home/LastKurantimePost'
import MarkedPositions from '@components/Home/MarkedPositions'
import PatreonBanner from '@components/shared/PatreonBanner'
import Stats from '@components/Home/Stats'
import { DefaultSeo } from 'next-seo'
import dynamic from 'next/dynamic'

const ReadingTimeWidget = dynamic(() => import('../components/Home/ReadingTimeWidget'), {
  ssr: false,
})

const PrayerTimesWidget = dynamic(
  () => import('../components/Home/PrayerTimes/PrayerTimesWidget'),
  {
    ssr: false,
  },
)

const ConnectionsWidget = dynamic(() => import('../components/Home/ConnectionsWidget'), {
  ssr: false,
})

const DailyGoalWidget = dynamic(
  () => import('../components/Home/DailyGoal/DailyGoalWidget'),
  { ssr: false },
)

export default function Home() {
  return (
    <>
      <DefaultSeo
        title="Hayırhah | Online Hayırhahınız!"
        description="Hayırhah, Kuran ve Cevşen gibi birçok duayı okuyabileceğiniz ve kaldığınız yeri farklı cihazlar arasında senkronize edebileceğiniz bir maneviyat programıdır."
      />
      <div className="flex flex-col pb-2">
        <HomePageSearchHero />
        <PatreonBanner />
        <PrayerTimesWidget />
        <DailyGoalWidget />
        <LastKurantimePost />
        <ReadingTimeWidget />
        <MarkedPositions />
        <Stats />
        <ConnectionsWidget />
      </div>
    </>
  )
}
